import VT from '@/store/types';

export default {
  [VT.LANGUAGES_LIST]: (state, { data, status }) => {
    state.languagesList = { data, status };
  },
  [VT.LANGUAGES_CLASSIFICATOR]: (state, { data, status }) => {
    state.languagesClassifier = { data: data.data, status };
  },
};
